import React, {useState} from 'react';
import {Button} from 'antd';
import {useAppContext} from '../libs/contextLib';
import fileDownload from 'js-file-download';
import {CloudDownloadOutlined} from '@ant-design/icons';
import { toGpxFormat } from '../libs/exportLib';
import { routeModelData, shiftBatModelData } from '../services/ModelService';

export default function GpxDownloadButton({route, routeId, shiftBat, shiftBatId}) {
    const {messageApi, isAdmin} = useAppContext();
    const [downloading, setDownloading] = useState(false);

    const handleDownload = async () => {
        setDownloading(true);
        try {
            let geoJsonable = route || shiftBat;
            if(!geoJsonable && routeId?.length > 0) {
                geoJsonable = await routeModelData.get(null, routeId);
            } else if(!geoJsonable && shiftBatId?.length > 0) {
                geoJsonable = await shiftBatModelData.get(null, shiftBatId);
            } else if(!geoJsonable) {
                messageApi.warning('Please provide a navigable object to download as GPX (routeId, shiftBatId)');
                return;
            }
            let file = await toGpxFormat(geoJsonable);
            fileDownload(file, `Busable_${geoJsonable.routeNumber || geoJsonable.shiftBatNumber}.gpx`, 'application/gpx');
            // send event back
            setDownloading(false);
        } catch (err) {
            console.log('Something went wrong: ', err);
            messageApi.error('Something went wrong while downloading files: '+err);
            setDownloading(false);
        }
    };

    if (!isAdmin) {
        return null;
    }

    return (
        <>
            <Button type="primary" className="icon-button btn-filled" icon={<CloudDownloadOutlined/>}
                    loading={downloading} onClick={handleDownload} />
        </>
    );
}
